import { Controller } from "@hotwired/stimulus"

const LAST_RUN_KEY = "offline_prewarm_at"
const MIN_INTERVAL_MS = 5 * 60 * 1000

// Fetches pages the user needs with no signal (the Kitchen the iOS app opens
// on, the grocery list in the store) so the service worker caches them before
// the first offline visit. redirect: "manual" keeps a signed-out redirect from
// being cached under the page's URL.
export default class extends Controller {
  static values = { urls: Array }

  connect() {
    if (navigator.serviceWorker?.controller) {
      // This page came through the service worker, so it's saved already.
      this.save({ skip: window.location.pathname })
    } else if (navigator.serviceWorker) {
      // First launch: the worker installs during this page's load. Once it
      // takes over, save everything, this page included.
      this.onControllerChange = () => this.save({ skip: null })
      navigator.serviceWorker.addEventListener("controllerchange", this.onControllerChange, { once: true })
    }
  }

  disconnect() {
    navigator.serviceWorker?.removeEventListener("controllerchange", this.onControllerChange)
  }

  save({ skip }) {
    if (!navigator.onLine || this.ranRecently()) return

    this.markRun()
    this.urlsValue
      .filter((url) => url !== skip)
      .forEach((url) => {
        fetch(url, { headers: { Accept: "text/html" }, redirect: "manual" }).catch(() => {})
      })
  }

  ranRecently() {
    try {
      return Date.now() - Number(localStorage.getItem(LAST_RUN_KEY)) < MIN_INTERVAL_MS
    } catch {
      return false
    }
  }

  markRun() {
    try {
      localStorage.setItem(LAST_RUN_KEY, String(Date.now()))
    } catch { /* storage blocked — warming every visit is fine */ }
  }
}
